<template>
    <!-- 表格列表里面的图片显示 -->
    <el-tooltip :placement="placement" effect="light">
            <div slot="content">
                <el-input type="textarea" :rows="4" disabled v-model="name" :style="{'width':width+'px'}"></el-input>
            </div>
            <span class="rule-name">{{name}}</span>
    </el-tooltip>
      
</template>

<script>

/**
* 
*
*     width    : 鼠标放大宽度
*     name      : 活动规则
*     placement: 鼠标放大显示在表格图片上下左右   默认为右边
*
**/


export default {
  name:"TableTxt",
  props:{
    width:{
      type:Number,
      default:120,
    },
    name:{
      type:String,
      default:'',
    },
    placement: {
      type:String,
      default:'bottom',
    }
  },
}
</script>

<style>
.rule-name {
  display: inline-block;
  width:120px;
  white-space:nowrap;
  text-overflow:ellipsis;
  overflow: hidden;
}
.el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  color: #606266;
  cursor:inherit;
}
</style>
